<template>
    <div id="file-upload-subsidiary-component">
        <div id="mainContent">

                <form id="formImport" class="formImport">
                    <div class="row justify-content-center scr-gap-15-0">
                        <div class="col-12 col-md-3">
                            <select name="role_id" v-model="subsidiary.role_id" v-on:change="selectProvider($event)" id="">
                                <option :value="0">Seleccione un Proveedor</option>
                                <option v-for="role in roles" :value="role.id">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3">
                            <select name="supplier_id" v-model="subsidiary.supplier_id" id="">
                                <option :value="0">Seleccione una Empresa</option>
                                <option v-for="provider in providers" :value="provider.id">{{ provider.proveedor }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="fotoUploader">
                            <span class="btn btn-file">
                                Archivo de Sucursales <br> <i class="fas fa-upload"></i> <input type="file" data-label="avatar" name="xlsFile" v-on:change="getFile" placeholder="avatar">
                            </span>
                                <span class="label-file-papeleria alert alert-info file"></span>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Cargar</button>
                        </div>
                    </div>
                </form>

        </div>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {supplierambulancesService} from "../../Services/SupplierAmbulances.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";
import {supplierinstitutionsService} from "../../Services/SupplierInstitutions.service";
import {supplierlaboratoriesService} from "../../Services/SupplierLaboratories.service";
import {supplierdentistsService} from "../../Services/SupplierDentists.service";
import {supplierradiologyService} from "../../Services/SupplierRadiologia.service";
import {supplieropticiansService} from "../../Services/SupplierOpticians.service";
import {importsubsidiaryfileService} from "../../Services/ImportSubsidiaryFile.service";
import {rolesService} from "../../Services/Roles.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "load-subsidiary-file",
    mixins: [myMixins],
    data() {
        return {
            roles: [],
            providers: [],
            subsidiary: {
                role_id: 0,
                supplier_id: 0,
            },
        }
    },
    methods: {

        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formImport');
            const formData = getFormData('formImport');
            if (respVal) {
                this.disableSubmitBtn(true);
                resp = await importsubsidiaryfileService.saveOne(formData, {isForm: true});
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },

        async index() {
            this.roles = await rolesService.getProvidersForSinester();
        },

        async selectProvider(event) {
            let id = this.stateId(event.target.value);
            switch (Number(id)) {
                case 3:
                    this.providers = await supplierambulancesService.getMany();
                    break;
                case 4:
                    this.providers = await supplierspecialistService.getMany();
                    break;
                case 7:
                    this.providers = await supplierinstitutionsService.getMany();
                    break;
                case 10:
                    this.providers = await supplierlaboratoriesService.getMany();
                    break;
                case 11:
                    this.providers = await supplierdentistsService.getMany();
                    break;
                case 12:
                    this.providers = await supplierradiologyService.getMany();
                    break;
                case 13:
                    this.providers = await supplieropticiansService.getMany();
                    break;
            }
        },

        getFile(event) {
            this.getNameFile(event, 'file');
        },

    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
.fotoUploader {
    margin-top: 0
}
</style>
